var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-vertical is-half" }, [
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Vehicle")]),
          _vm.vehicle && !_vm.vehicle.isActive
            ? _c("p", { staticClass: "subtitle has-text-danger" }, [
                _vm._v("This vehicle has been deleted"),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c(
              "table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                class: { "is-loading-no-header": _vm.isVehicleLoading },
              },
              [
                !_vm.isVehicleLoading && _vm.vehicle
                  ? _c("tbody", [
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Rego"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.rego))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Make"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.model.make))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Model"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.model.model))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Series"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.model.make))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Built"),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.pad(_vm.vehicle.buildMonth, 2)
                            ) +
                              _vm._s(_vm.vehicle.buildMonth ? "/" : "") +
                              _vm._s(_vm.vehicle.buildYear)
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Engine Size"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.engizeSize))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("VIN"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.vin))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Body Style"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.bodyId2))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Colour"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.colour))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Engine No."),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.engineNo))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Cylinders"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.cylinders))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Transmission"),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.vehicle.transmissionType)),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Paint Group"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.paintGroup))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("NRMA Schedule"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.scheduleId))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("NTAR Schedule"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.ntarScheduleId))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("MTA Schedule"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.mtaScheduleId))]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "has-text-weight-bold" }, [
                          _vm._v("Odometer"),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.vehicle.odometer))]),
                      ]),
                    ])
                  : _vm.isVehicleLoading
                  ? _c("tbody", [_vm._m(0)])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "tile is-vertical is-half" }, [
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Customer")]),
          _vm.customer && !_vm.customer.active
            ? _c("p", { staticClass: "subtitle has-text-danger" }, [
                _vm._v("This customer has been deleted"),
              ])
            : _vm._e(),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
              class: { "is-loading-no-header": _vm.isCustomerLoading },
            },
            [
              !_vm.isCustomerLoading && _vm.customer
                ? _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _c("span", [_vm._v("Name")]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  this.$v.vehicleCustomerInsurerGroup.$error,
                                expression:
                                  "this.$v.vehicleCustomerInsurerGroup.$error",
                              },
                            ],
                            staticClass:
                              "icon has-text-danger tooltip is-tooltip-danger is-tooltip-multiline",
                            attrs: {
                              "data-tooltip":
                                "Quote's customer does not match vehicle's customer. Click button next to name to fix.",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-alert-circle mdi-18px",
                            }),
                          ]
                        ),
                      ]),
                      _c("td", [
                        _vm._v(" " + _vm._s(_vm.customer.fullname) + " "),
                        _vm.customer && !_vm.customer.active
                          ? _c(
                              "span",
                              { staticClass: "tag is-danger is-light" },
                              [_vm._v("Deleted")]
                            )
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  this.$v.vehicleCustomerInsurerGroup.$error,
                                expression:
                                  "this.$v.vehicleCustomerInsurerGroup.$error",
                              },
                            ],
                            staticClass:
                              "button is-small is-outlined is-danger is-pulled-right tooltip is-tooltip-topright",
                            attrs: {
                              "data-tooltip":
                                "Auto fix customer mismatch issue",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.fixCustomerMismatch()
                              },
                            },
                          },
                          [_vm._m(1)]
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Address"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.customerDefaultAddress
                              ? _vm.customerDefaultAddress.displayAddress
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Phone"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.customerDefaultPhone
                              ? _vm.customerDefaultPhone.no
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Mobile"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.customerMobilePhone
                              ? _vm.customerMobilePhone.no
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Fax"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.customerFax ? _vm.customerFax.no : "")
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Email"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.customerDefaultEmail
                              ? _vm.customerDefaultEmail.address
                              : ""
                          )
                        ),
                      ]),
                    ]),
                  ])
                : _vm.isCustomerLoading
                ? _c("tbody", [_vm._m(2)])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Insurer")]),
          _vm.insurer && !_vm.insurer.active
            ? _c("p", { staticClass: "subtitle has-text-danger" }, [
                _vm._v("This insurer has been deleted"),
              ])
            : _vm._e(),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
              class: { "is-loading-no-header": _vm.isInsurerLoading },
            },
            [
              !_vm.isInsurerLoading && _vm.insurer
                ? _c("tbody", [
                    _c("tr", [
                      _vm._m(3),
                      _c("td", [
                        _vm._v(" " + _vm._s(_vm.insurer.name) + " "),
                        _vm.insurer && !_vm.insurer.active
                          ? _c(
                              "span",
                              { staticClass: "tag is-danger is-light" },
                              [_vm._v("Deleted")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Address"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.insurerDefaultAddress
                              ? _vm.insurerDefaultAddress.displayAddress
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Phone"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.insurerDefaultPhone
                              ? _vm.insurerDefaultPhone.no
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Mobile"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.insurerMobilePhone
                              ? _vm.insurerMobilePhone.no
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Fax"),
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.insurerFax ? _vm.insurerFax.no : "")),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "has-text-weight-bold" }, [
                        _vm._v("Email"),
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.insurerDefaultEmail
                              ? _vm.insurerDefaultEmail.address
                              : ""
                          )
                        ),
                      ]),
                    ]),
                  ])
                : _vm.isInsurerLoading
                ? _c("tbody", [_vm._m(4)])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c(
                "span",
                {
                  staticStyle: { opacity: "0" },
                  attrs: { icon: "icon is-large" },
                },
                [_c("i", { staticClass: "mdi mdi-spin mdi-loadingmdi-36px" })]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-auto-fix mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c(
                "span",
                {
                  staticStyle: { opacity: "0" },
                  attrs: { icon: "icon is-large" },
                },
                [_c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-36px" })]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "has-text-weight-bold" }, [
      _c("span", [_vm._v("Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c(
                "span",
                {
                  staticStyle: { opacity: "0" },
                  attrs: { icon: "icon is-large" },
                },
                [_c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-36px" })]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }